import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"

const AdminCeduladosComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()

  return (<>
    <CRUD
      isModal={false}

      id="cedulados"
      cssClass="modalRight"
      showModal={props.show}
      toggleCRUD={props.toggle}
      filterOpen={true}
      title={t("Cedulados") ?? ""}
      icon={"fas fa-users"}
      recordButtonsPosition="start"
      getRecordsPath={`cedulados/list`}
      getRecordsMethod="post"
      addEditRecordPath={`cedulados/AddEdit?currentUserId=${user.ID}`}
      deleteRecordPath="cedulados/delete"
      filterFields={[


        {
          name: "cedula",
          htmlType: "text",
          dbType: "string",
          title: "cedula",
          containerClass: "col-12 col-md-4",
          required: false,
        },

      ]}
      fieldsList={[
        {
          name: "cedula",
          title: t("Informe "),
          htmlType: "informe"
        },
        {
          name: "nombres",
          title: t("Nombres"),
        },
        {
          name: "apellido1",
          title: t("Primer Apellido"),
        },
        {
          name: "apellido2",
          title: t("Segundo Apellido"),
        },
        {
          name: "cedula",
          title: t("Cédula"),
        },

      ]}
      fields={[
        { name: "MunCed", htmlType: "text", dbType: "string", title: t("Municipio Cedula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "SeqCed", htmlType: "text", dbType: "string", title: t("Secuencia Cedula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "VerCed", htmlType: "text", dbType: "string", title: t("Verificación Cedula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "Nombres", htmlType: "text", dbType: "string", title: t("Nombres") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "Apellido1", htmlType: "text", dbType: "string", title: t("Primer Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Apellido2", htmlType: "text", dbType: "string", title: t("Segundo Apellido") ?? "", containerClass: "col-12 col-md-6" },
        { name: "FechaNac", htmlType: "date", dbType: "DateTime", title: t("Fecha de Nacimiento") ?? "", containerClass: "col-12 col-md-6" },
        { name: "LugarNac", htmlType: "text", dbType: "string", title: t("Lugar de Nacimiento") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedANum", htmlType: "text", dbType: "string", title: t("Número Cedula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedASeri", htmlType: "text", dbType: "string", title: t("Serie Cedula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedASexo", htmlType: "text", dbType: "string", title: t("Sexo Cedula") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Calle", htmlType: "text", dbType: "string", title: t("Calle") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Casa", htmlType: "text", dbType: "string", title: t("Casa") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Edificio", htmlType: "text", dbType: "string", title: t("Edificio") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Piso", htmlType: "text", dbType: "string", title: t("Piso") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Apto", htmlType: "text", dbType: "string", title: t("Apto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Telefono", htmlType: "text", dbType: "string", title: t("Teléfono") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodMunicipio", htmlType: "text", dbType: "string", title: t("Código Municipio") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodCiudad", htmlType: "text", dbType: "string", title: t("Código Ciudad") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodSector", htmlType: "text", dbType: "string", title: t("Código Sector") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodPiel", htmlType: "number", dbType: "decimal", title: t("Código Piel") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodSangre", htmlType: "number", dbType: "decimal", title: t("Código Sangre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Sexo", htmlType: "text", dbType: "string", title: t("Sexo") ?? "", containerClass: "col-12 col-md-6" },
        { name: "SenasPart", htmlType: "text", dbType: "string", title: t("Señas Particulares") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodOcup", htmlType: "number", dbType: "decimal", title: t("Código Ocupación") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodNacion", htmlType: "number", dbType: "decimal", title: t("Código Nacionalidad") ?? "", containerClass: "col-12 col-md-6" },
        { name: "EstCivil", htmlType: "text", dbType: "string", title: t("Estado Civil") ?? "", containerClass: "col-12 col-md-6" },
        { name: "NumPasapo", htmlType: "text", dbType: "string", title: t("Número Pasaporte") ?? "", containerClass: "col-12 col-md-6" },
        { name: "NumReside", htmlType: "text", dbType: "string", title: t("Número Residencia") ?? "", containerClass: "col-12 col-md-6" },
        { name: "FechaExpiracion", htmlType: "date", dbType: "DateTime", title: t("Fecha Expiración") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Categoria", htmlType: "text", dbType: "string", title: t("Categoría") ?? "", containerClass: "col-12 col-md-6" },
        { name: "TipoCausa", htmlType: "text", dbType: "string", title: t("Tipo Causa") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CodCausa", htmlType: "number", dbType: "decimal", title: t("Código Causa") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Estatus", htmlType: "text", dbType: "string", title: t("Estatus") ?? "", containerClass: "col-12 col-md-6" },
        { name: "FechaCancelacion", htmlType: "date", dbType: "DateTime", title: t("Fecha Cancelación") ?? "", containerClass: "col-12 col-md-6" },
        { name: "NumeroOficio", htmlType: "number", dbType: "decimal", title: t("Número Oficio") ?? "", containerClass: "col-12 col-md-6" },
        { name: "FechaRevalidacion", htmlType: "date", dbType: "DateTime", title: t("Fecha Revalidación") ?? "", containerClass: "col-12 col-md-6" },
        { name: "NumeroOficioRevalidacion", htmlType: "number", dbType: "decimal", title: t("Número Oficio Revalidación") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedulaPadre", htmlType: "cedula", dbType: "string", title: t("Cédula Padre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedulaMadre", htmlType: "cedula", dbType: "string", title: t("Cédula Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedulaConyugue", htmlType: "cedula", dbType: "string", title: t("Cédula Cónyuge") ?? "", containerClass: "col-12 col-md-6" },
        { name: "PadreNombres", htmlType: "text", dbType: "string", title: t("Nombres Padre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "PadreApellido1", htmlType: "text", dbType: "string", title: t("Primer Apellido Padre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "PadreApellido2", htmlType: "text", dbType: "string", title: t("Segundo Apellido Padre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "MadreNombres", htmlType: "text", dbType: "string", title: t("Nombres Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "MadreApellido1", htmlType: "text", dbType: "string", title: t("Primer Apellido Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "MadreApellido2", htmlType: "text", dbType: "string", title: t("Segundo Apellido Madre") ?? "", containerClass: "col-12 col-md-6" },
        { name: "ConyugueNombres", htmlType: "text", dbType: "string", title: t("Nombres Cónyuge") ?? "", containerClass: "col-12 col-md-6" },
        { name: "ConyugueApellido1", htmlType: "text", dbType: "string", title: t("Primer Apellido Cónyuge") ?? "", containerClass: "col-12 col-md-6" },
        { name: "ConyugueApellido2", htmlType: "text", dbType: "string", title: t("Segundo Apellido Cónyuge") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Donante", htmlType: "text", dbType: "string", title: t("Donante") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Cedula", htmlType: "cedula", dbType: "string", title: t("Cédula") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "Edad", htmlType: "number", dbType: "int", title: t("Edad") ?? "", containerClass: "col-12 col-md-6" },
        { name: "Foto", htmlType: "picture", dbType: "int", title: t("Foto") ?? "", containerClass: "col-12 col-md-6" },
        { name: "CedulaGuion", htmlType: "text", dbType: "string", title: t("Cédula con Guion") ?? "", containerClass: "col-12 col-md-6" },
        { name: "NombreCompleto", htmlType: "text", dbType: "string", title: t("Nombre Completo") ?? "", containerClass: "col-12 col-md-6" },
        { name: "HashId", htmlType: "hidden", dbType: "string", title: t("Hash Id") ?? "", containerClass: "col-12 col-md-6", required: true },
        { name: "Guid", htmlType: "hidden", dbType: "string", title: t("Guid") ?? "", containerClass: "col-12 col-md-6", required: true },
      ]}
    />
  </>
  )
}

export default AdminCeduladosComponent
